import React, {useState, useEffect, useRef} from "react";
import {FlexContainer} from "BaseComponents/Flex";
import {InnerBlockContainer, ContentContainer} from "BaseComponents/Wrappers";
import {ToggleCheckbox as Checkbox} from "BaseComponents/ToggleCheckbox";
import styled, {css} from "styled-components";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import {ButtonText, PrimarySubmitButton} from "Buttons";
import {Paragraph} from "BaseComponents/Text";
import {CookieHandler as CookieManager} from "../../framework/handlers/CookieHandler";
import * as COOKIETYPES from "../../framework/consts/cookieTypes";
import {cookieBarActions} from "../../framework/redux/actions/index";
import {useSelector, useDispatch} from "react-redux";
import {useGlobal} from "reactn";
import {Link} from "BaseComponents/Link";

const CookieHandler = new CookieManager(true);
export const Cookie = ({
                           Text,
                           AgreeChoosen,
                           AgreeAll,
                           Statistic,
                           Performance,
                           Settings,
                           Needed,
                           currentPageId,
                           CookieInfoLinkText,
                           CookieInfoLinkUrl,
                           HideCookiesBanner
                       }) => {
    const dispatch = useDispatch();
    const cookieBarstate = useSelector(({cookiebar}) => cookiebar);
    let childRef = useRef();

    const [showSettings, setShowSettings] = useState(false);
    const [performanceVal, setPerformance] = useState(
        CookieHandler.get(COOKIETYPES.COOKIE_PERFORMANCE) !== undefined
    );
    const [statisticsVal, setStatistics] = useState(
        CookieHandler.get(COOKIETYPES.COOKIE_STATISTICS) !== undefined
    );
    const [showCheckboxes, setShowCheckboxes] = useState(false);

    const [theme] = useGlobal("theme");
    const {acceptCookie} = cookieBarActions;

    useEffect(() => {
        setShowSettings(!cookieBarstate.accepted);
    }, [cookieBarstate]);
    useEffect(() => {
        if (!showSettings) {
            setStatistics(
                CookieHandler.get(COOKIETYPES.COOKIE_STATISTICS) !== undefined
            );
            setPerformance(
                CookieHandler.get(COOKIETYPES.COOKIE_PERFORMANCE) !== undefined
            );
        }
    }, [showSettings]);
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowSettings(!CookieHandler.shouldSaveCookies());
        }, 1000);
        return () => clearTimeout(timer);
    }, []);
    const handleBtnClick = (e) => {
        e.preventDefault();
        setShowSettings(false);
        dispatch(
            acceptCookie(false, statisticsVal, false, performanceVal, currentPageId)
        );
    };

    const handleClick = () => {
        setShowCheckboxes(!showCheckboxes);
        const {current} = childRef;
        current.style.height = !showCheckboxes ? current.scrollHeight + "px" : 0;
    };
    return (
        !HideCookiesBanner ?
            <CookieWrapper className="cookie_popup" show={showSettings}>
                <InnerBlockContainer>
                    <ContentContainer
                        justifyContent="space-between"
                        flexWrap="wrap"
                        smallPadding="1rem 0 0 0"
                        padding="0"
                        alignItems="center"
                    >
                        {Text && (
                            <ContentContainer smallPadding="1rem 0" padding="1rem 1rem 0 0">
                                <Paragraph maxwidth="713px" fontSize="18px" fontSizeSmall="16px">
                                    {Text}
                                    {CookieInfoLinkUrl ? (
                                        <Link
                                            hidden={!showSettings}
                                            color={theme.colors.primary}
                                            target="_blank"
                                            href={CookieInfoLinkUrl}
                                            text={CookieInfoLinkText}
                                        />
                                    ) : null}
                                </Paragraph>
                            </ContentContainer>
                        )}
                        <ContentContainer
                            alignItems="center"
                            smallPadding="1rem 0"
                            padding="1rem 0 0 0"
                            smallAlignItems="stretch"
                        >
                            <PrimarySubmitButton
                                tabIndex={showSettings ? "0" : "-1"}
                                wide
                                inverted
                                height="33px"
                                margin="0 0 0 1rem"
                                marginsmall="10px 0 0 0"
                                onClick={(e) => {
                                    dispatch(acceptCookie(true, true, true, true, currentPageId));
                                    setShowSettings(false);
                                    e.preventDefault();
                                }}
                                type={"button"}
                            >
                                <ButtonText
                                    fontWeight="normal"
                                    forcedfontSizeSmall="18px"
                                    fontSize="14px"
                                    heading={`cookie button`}
                                >
                                    {AgreeAll}
                                </ButtonText>
                            </PrimarySubmitButton>
                            {showCheckboxes ? (
                                <PrimarySubmitButton
                                    tabIndex={showSettings ? "0" : "-1"}
                                    wide
                                    height="33px"
                                    widthsmall="100%"
                                    marginsmall="0"
                                    onClick={(e) => handleBtnClick(e)}
                                    type={"button"}
                                >
                                    <ButtonText
                                        fontWeight="normal"
                                        forcedfontSizeSmall="18px"
                                        fontSize="14px"
                                        heading={`agree cookie button`}
                                    >
                                        {AgreeChoosen}
                                    </ButtonText>
                                </PrimarySubmitButton>
                            ) : (
                                <PrimarySubmitButton
                                    tabIndex={showSettings ? "0" : "-1"}
                                    wide
                                    height="33px"
                                    marginsmall="10px 0 0 0"
                                    margin="0 0 0 1rem"
                                    onClick={handleClick}
                                type="button"
                                >
                                    <ButtonText
                                        fontWeight="normal"
                                        forcedfontSizeSmall="18px"
                                        fontSize="14px"
                                        heading={`settings button`}
                                    >
                                        {Settings}
                                    </ButtonText>
                                </PrimarySubmitButton>
                            )}
                        </ContentContainer>
                    </ContentContainer>
                    <AnimatedWrapper ref={childRef} padding="0" show={showCheckboxes}>
                        <CookieBottom transition="0.5s ease" show={showCheckboxes}>
                            <ContentContainer
                                flexWrap="wrap"
                                smallFlexDirection="row"
                                smallPadding="0 0 1rem 0"
                                padding="1rem 0"
                            >
                                <Checkbox
                                    margin="0 10px 0 0"
                                    disabled
                                    label={Needed}
                                    onChangeFunc={() => {
                                    }}
                                    hidden={!showCheckboxes}
                                />
                                <Checkbox
                                    margin="0 10px 0 0"
                                    hidden={!showCheckboxes}
                                    label={Performance}
                                    isSet={performanceVal}
                                    onChangeFunc={() => setPerformance(!performanceVal)}
                                />
                                <Checkbox
                                    hidden={!showCheckboxes}
                                    label={Statistic}
                                    isSet={statisticsVal}
                                    onChangeFunc={() => setStatistics(!statisticsVal)}
                                />
                            </ContentContainer>
                        </CookieBottom>
                    </AnimatedWrapper>
                </InnerBlockContainer>
            </CookieWrapper> : <></>
    );
};
export const CookieOuter = styled.div`
    position: relative;
    z-index: 900;
`;
export const CookieWrapper = styled(FlexContainer).attrs(({show}) => ({
    flexdirection: "column",
    show: show ? show : false,
    ariaHidden: show ? "false" : "true",
}))`
    position: fixed;
    bottom: 0;
    height: auto;
    background: white;
    transform: ${({show}) => (show ? "translateY(0)" : "translateY(100%)")};
    width: 100%;
    z-index: 900;
    transition: transform 0.7s cubic-bezier(0.83, 0, 0.17, 1);
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.3);
    padding: 2rem 5rem;

    ${media.lessThan(breakpoints.ipad)`
  padding: 1rem 1rem;
  
  `}
    ${media.lessThan(breakpoints.mobile)`
  padding: 0;

  `}
    ${PrimarySubmitButton} {
        height: 35px;
        ${media.greaterThan(breakpoints.mobile)`
		&:not(:first-of-type){
			margin-left:10px; 

		}
	
		`}
    }
`;
const CookieBottom = styled.div.attrs(({show}) => {
    return {
        "aria-hidden": show ? "false" : "true",
    };
})`
    opacity: ${({show}) => (show ? 1 : 0)};
    display: flex;
    width: 100%;
    align-items: center;

    overflow: hidden;
    transition: 0.5s ease-out;
`;

const AnimatedWrapper = styled.div`
    position: relative;
    transition: transform 0.35s ease-in-out, opacity 0.3s ease-in-out,
    height 0.2s ease-in-out;

    ${({show, height}) =>
            show
                    ? css`
                        height: ${height}px;
                        transform: translateY(0);
                        opacity: 1;
                        z-index: 1;
                    `
                    : css`
                        opacity: 0;
                        height: 0;
                        z-index: 0;
                        transform: translateY(30%);
                    `}
`;
